import React from "react";
import "../rapidFire/StartRapidHeader.css";
import "../DashboardSkeleton.css";
import "./ExamCourseHeader.css";
import Inquiry from "../../assets/images/inquire-icon.png";
import InfoIcon from "../../assets/images/info-icon.png";

const ExamCourseHeader = ({ masterExam = {}, isLoading = false }) => {
  const title = masterExam?.master_exam_name || "Exam Courses";
  const description = masterExam?.master_exam_short_description || "Choose an exam course to start preparing.";
  const enrolledCount = Number(masterExam?.master_exam_favourite_count || 0);
  const studentImage = masterExam?.master_exam_students_img || "";
  const titleWords = title.trim().split(/\s+/);
  const highlightedTitle = titleWords.pop();

  return (
    <>
      <div className="qb-body">
        <div className="d-flex align-items-center justify-content-center">
          <div className="rapid-fire-card examCardd">
            <div className="rapid-fire-header ex-header">
              <h1 className="qb-title">
                {isLoading ? "Loading exam courses..." : <>{titleWords.join(" ")} <span>{highlightedTitle}</span></>}
              </h1>
            </div>
            <p className="game-description">{isLoading ? "" : description}</p>
            <div className="enrollment-section">
              <div className="enrollment-card">
                <div className="student-avatars">
                  {studentImage ? <img src={studentImage} alt="Enrolled students" className="master-students-image" /> : null}
                </div>
                <div className="student-count">{enrolledCount.toLocaleString()}+ Student Enrolled</div>
              </div>
              <div className="enrollment-actions">
                <button type="button" className="info-action"><span className="action-icon info-icon"><img src={InfoIcon} alt="" /></span><span>Info & Updates</span></button>
                <button type="button" className="info-action"><span className="action-icon inquiry-icon"><img src={Inquiry} alt="" /></span><span>Inquire Now</span></button>
              </div>
            </div>
          </div>
          <div className="qb-visual gamification-visual" aria-hidden="true">
            {isLoading ? <span className="master-exam-image-shimmer dashboard-skeleton" /> : null}
            {!isLoading && masterExam?.master_exam_image ? <img src={masterExam.master_exam_image} alt="" className="qb-hero master-exam-image" /> : null}
          </div>
        </div>
      </div>
    </>
  );
};

export default ExamCourseHeader;
